import { ReceiveBatchTable } from './ReceiveBatchTable'

export default ReceiveBatchTable
